// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';
/**
 * Credit score related helpers
 */

var Actions = require('./actions');

var Reducers = require('./reducers');

export { Actions, Reducers };
/**
@enum BucketName
*/

export var BucketName = {
  user: 'user',
  poor: 'poor',
  average: 'average',
  good: 'good',
  excellent: 'excellent'
}; // This array defines the order of buckets

export var ficoArray = [BucketName.poor, BucketName.average, BucketName.good, BucketName.excellent]; // This is where we define bounds for each bucket

export var ficoMap = {
  poor: {
    min: 300,
    max: 629
  },
  average: {
    min: 630,
    max: 689
  },
  good: {
    min: 690,
    max: 719
  },
  excellent: {
    min: 720,
    max: 850
  }
}; // This is where we define bucket labels

export var FilterOptionLabels = {
  poor: 'Poor (300-629)',
  average: 'Average (630-689)',
  good: 'Good (690-719)',
  excellent: 'Excellent (720-850)'
};
export var getFilterOptionLabel = function getFilterOptionLabel(bucketName, userCreditScore) {
  var filterOptionLabels = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : FilterOptionLabels;

  if (bucketName === BucketName.user) {
    return "".concat(userCreditScore, " (Your Score)");
  }

  return filterOptionLabels[bucketName];
};
/**
Given a score, returns the bucket name the score falls into
@param {number} - credit score to be tested
@returns {BucketName} - name of the bucket which score falls into
*/

export var getBucketFromScore = function getBucketFromScore(score) {
  if (score >= ficoMap.excellent.min) {
    return BucketName.excellent;
  }

  if (score >= ficoMap.good.min) {
    return BucketName.good;
  }

  if (score >= ficoMap.average.min) {
    return BucketName.average;
  }

  return BucketName.poor;
};
/**
 * Get order index of a given credit score bucket.
 *
 * @param {string} creditScoreBucket Credit score bucket.
 *
 * @return {number} Order index of the credit score bucket.
 */

export var getCreditScoreBucketIndex = function getCreditScoreBucketIndex(creditScoreBucket) {
  return ficoArray.indexOf(creditScoreBucket);
};
/**
 * Get the max credit score value for a given bucket.
 *
 * @param {string} creditScoreBucket Credit score bucket.
 *
 * @return {number} Credit score bucket max numeric value.
 */

export var getCreditScoreBucketValueMax = function getCreditScoreBucketValueMax(creditScoreBucket) {
  return get(ficoMap, [creditScoreBucket, 'max']);
};
/**
 * Get the min credit score value for a given bucket.
 *
 * @param {string} creditScoreBucket Credit score bucket.
 *
 * @return {number} Credit score bucket min numeric value.
 */

export var getCreditScoreBucketValueMin = function getCreditScoreBucketValueMin(creditScoreBucket) {
  return get(ficoMap, [creditScoreBucket, 'min']);
};
/**
To be used with Array.sort() to get ascending sort
@param {BucketName} a - name of the bucket
@param {BucketName} b - name of the bucket
@returns {number} - -1 if b > a, 1 if a < b, 0 if a == b
*/

export var sortBucketsAscending = function sortBucketsAscending(a, b) {
  var orderA = getCreditScoreBucketIndex(a);
  var orderB = getCreditScoreBucketIndex(b);

  if (orderB === orderA) {
    return 0;
  }

  if (orderB > orderA) {
    return -1;
  }

  return 1;
};
/**
To be used with Array.sort() to get descending sort. Calls
sortBucketsAscending internally.
@param {BucketName} a - name of the bucket
@param {BucketName} b - name of the bucket
@returns {number} - -1 if a > b, 1 if b < a, 0 if a == b
*/

export var sortBucketsDescending = function sortBucketsDescending(a, b) {
  return sortBucketsAscending(b, a);
};